import { createContext, useState } from 'react';

export type TypePlaceData = {
  buildingName: string,
  sectionName: string,
};

interface StepperData {
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  editMode: boolean;
  setEditMode: React.Dispatch<React.SetStateAction<boolean>>;
  placeData: TypePlaceData;
  setPlaceData: React.Dispatch<React.SetStateAction<TypePlaceData>>;
};

const StepperContext = createContext<StepperData>({} as StepperData);

export const StepperProvider: React.FC = ({ children }) => {
  const [step, setStep] = useState(0);
  const [editMode, setEditMode] = useState(false);
  const [placeData, setPlaceData] = useState<TypePlaceData>({} as TypePlaceData);

  return (
    <StepperContext.Provider
      value={{
        step,
        setStep,
        editMode,
        setEditMode,
        placeData,
        setPlaceData
      }}
    >
      {children}
    </StepperContext.Provider>
  );
};

export default StepperContext;